/// <reference path='../../../../typings/index.d.ts' />
/// <reference path='customBranding.module.ts' />

module Meevo.Plugins.CustomBranding {

    class CustomBrandingController extends Meevo.Components.CommonClasses.CommonControllerBase {
        showCOBar: boolean = false;

        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.BusinessInfoDataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',

            'meevo.components.busy.BusyService',
            '$translate',
            '$q'
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected dataService: Meevo.Components.Common.BusinessInfoDataService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected loggingService: Meevo.Components.Logging.ILoggingService,
                    protected securityService: Meevo.Components.Common.ISecurityService,
                    protected trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $scope: angular.IScope,
                    protected $state: any,
                    protected contextParams: Meevo.IContextParams,
                    protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $translate: angular.translate.ITranslateService,
                    protected $q: ng.IQService
        ) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.createContext();
        }

        createContext(): void {
            this.busyService.start();

            this.securityService.checkSection(this.meevoSecurityKeys.MANAGEMENT_CUSTOMBRANDING).then(() => {
                this.busyService.stop();
                this.context = new CustomBrandingContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.busyService, this.$translate, this.$q);
                super.createContext();
            });
        }
    }

    angular.module('meevo.plugins.customBranding')
        .controller('meevo.plugins.customBranding.CustomBrandingController', CustomBrandingController);
}